export enum CursorStyle {
    Full  ,
    SolidCircle,
    BorderedCircle
}

export enum OthersCursorMode {
    All, // Cursors from all other users will be visible
    None, // Cursors from other users will not be visible
    HostOnly// Cursors from the board host will be visible, but not from other users
}
